import { handleActions } from 'redux-actions'
import {
  updateHrefs,
  fetchCard,
  fetchCardSuccess,
  fetchCardFailure,
} from './actions'
import {
  CardState,
  CardAndStatus,
} from './models'

export default handleActions({
  [updateHrefs]: (state, action) => {
    return state.mergeIn(['hrefsByMessageId'], action.payload)
  },
  [fetchCard]: (state, action) => {
    return state.setIn(['cardsByHref', action.payload], new CardAndStatus({
      href: action.payload,
    }))
  },
  [fetchCardSuccess]: (state, action) => {
    return state.mergeIn(['cardsByHref', action.payload.href], {
      card: action.payload.card,
      status: 'success',
    })
  },
  [fetchCardFailure]: (state, action) => {
    return state.setIn(['cardsByHref', action.payload.href, 'status'], 'failure')
  },
}, new CardState())



// WEBPACK FOOTER //
// ./src/scripts/app/modules/cards/reducer.js